// Credit https://dev.to/spaquet/rails-popper-tailwind-stimulus-1koi

import { Controller } from "@hotwired/stimulus"
import { createPopper } from "@popperjs/core"

// Connects to data-controller="tooltip"
export default class extends Controller {
  
  static targets = ["content"]
  
  static values = {
    placement: { type: String, default: "top" },
    offset: { type: Array, default: [0, 0] },
    delay: { type: Number, default: 0 },
    strategy: { type: String, default: "absolute" }
  }
  static classes = ["hidden"]
  
  connect() {
    if (!this.hasContentTarget) return

    this.tooltipElement = this.contentTarget
    this.referenceElement = this.findReferenceElement()
    document.body.appendChild(this.tooltipElement)

    this.popperInstance = createPopper(this.referenceElement, this.tooltipElement, {
      placement: this.placementValue,
      strategy: this.strategyValue,
      modifiers: [
        { name: "offset", options: { offset: this.offsetValue } }
      ]
    })
  }

  show() {
    if (!this.popperInstance) return
    if (this.timeout) clearTimeout(this.timeout)
    if (this.delayValue) {
      this.timeout = setTimeout(this.showTooltip.bind(this), this.delayValue)
    } else {
      this.showTooltip()
    }
  }

  hide() {
    if (!this.popperInstance) return
    this.timeout && clearTimeout(this.timeout)
    this.tooltipElement.classList.add(this.hiddenClass)
    this.popperInstance.update()
  }

  showTooltip() {
    this.tooltipElement.classList.remove(this.hiddenClass)
    this.popperInstance.update()
  }

  disconnect() {
    this.hide()
    this.popperInstance && this.popperInstance.destroy()
    this.timeout && clearTimeout(this.timeout)
    this.tooltipElement && this.tooltipElement.remove()
  }

  findReferenceElement() {
    return [...this.element.children].find((child) => child !== this.contentTarget) || this.element
  }

}
